export default "__VITE_ASSET__79ad68a7__"